import { FC, useEffect } from 'react';

import { ChatModal } from '@pp/core/src/components/chat/chatModal/ChatModal';
import { Logger } from '@pp/core/src/logger/Logger';
import { CoreSessionStorage } from '@pp/core/src/storage/session/CoreSessionStorage';
import { useCoreDispatch } from '@pp/core/src/store/CoreStore';
import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';
import { headerActions } from '@pp/core/src/store/slices/header/slice';
import { HeaderModal } from '@pp/core/src/store/slices/header/types';
import { useIsLargerThanWide } from '@pp/core/src/styles/hooks/media';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import { useHighflyerGameStateSlice } from '../../../../store/slices/highflyerGame/selectors';
import { highflyerGameStateActions } from '../../../../store/slices/highflyerGame/slice';

import { CrashChatConnected } from './CrashChatConnected';

import styles from './ChatCellConnected.module.css';

export const ChatCellConnected: FC = () => {
  const dispatch = useCoreDispatch();
  const disabledJurisdictionChat = !!useConfigSlice.jurisdiction()?.disableChat;
  const isChatDisabled = useConfigSlice.isChatDisabled();
  const isGameChat = useHighflyerGameStateSlice.getSelectedHeader() == HeaderModal.Chat; 
  const isGameSupport = useHighflyerGameStateSlice.getSelectedHeader() == HeaderModal.Support;
  const title = isGameChat ? 'CHAT' : isGameSupport ? 'LIVE_SUPPORT' : 'CHAT';
  const isWideScreen: boolean = useIsLargerThanWide();
  const isChatVisible = useConfigSlice.isChatVisibleByDefault();
  const isChatModalClosed: boolean = useHighflyerGameStateSlice.getChatClosed();

  const chatMods = useModifiers(
    styles,
    'chatCellContainer',
    {
      closed: isChatModalClosed,
    },
    { withBaseClass: true }
  );

  useEffect(() => {
    if (isWideScreen) {
      CoreSessionStorage.setIsChatClosed(isChatModalClosed);
      dispatch(highflyerGameStateActions.setChatClosed(isChatModalClosed));
      if (isChatModalClosed) dispatch(headerActions.setOpenedModal(null));
      else dispatch(headerActions.setOpenedModal(HeaderModal.Chat));
    }
  }, [dispatch, isWideScreen, isChatModalClosed]);

  useEffect(() => {
    if (isChatVisible) return;
    CoreSessionStorage.setIsChatClosed(isChatVisible);
    dispatch(highflyerGameStateActions.setChatClosed(isChatVisible));
    if (isChatVisible) dispatch(headerActions.setOpenedModal(HeaderModal.Chat));
    else dispatch(headerActions.setOpenedModal(null));
  }, [dispatch]);

  useEffect(() => {
    if (isChatDisabled || disabledJurisdictionChat) {
      CoreSessionStorage.setIsChatClosed(isChatDisabled || disabledJurisdictionChat);
      dispatch(highflyerGameStateActions.setChatClosed(isChatDisabled || disabledJurisdictionChat));
      dispatch(headerActions.setOpenedModal(null));
    }
  }, [dispatch]);

  const handleCloseModal = (): void => {
    CoreSessionStorage.setIsChatClosed(true);
    dispatch(highflyerGameStateActions.setChatClosed(true));
    dispatch(highflyerGameStateActions.setSelectedHeader(null));
    if (isWideScreen) {
      dispatch(headerActions.setOpenedModal(null));
    }
    Logger.logEvent('click', 'chatModalClosed', Date.now(), 1, '', false);
  };
  if (isChatDisabled) {
    return null;
  }
  return (
    <div className={chatMods}>
      <ChatModal
        isChatModalOpen={!isChatModalClosed}
        onClose={handleCloseModal}
        title={title}
        fullScreenNoClose
        draggable={false}
      >
        <CrashChatConnected />
      </ChatModal>
    </div>
  );
};
